import apiService from 'src/shared/config/apiService';
import { OrderQuote } from 'src/shared/types/quote';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

const getProductQuotes = async (id: string) => {
  try {
    const response = await apiService.get<OrderQuote[]>(
      `/products/${id}/quotes`
    );

    return response;
  } catch (error) {
    throw handleAxiosError(error);
  }
};

export default getProductQuotes;
